import { AppState } from 'Store'

const getArticle = (state: AppState) => state.knowledge.article.article
const getArticles = (state: AppState) => state.knowledge.article.data
const getQuery = (state): string => state.knowledge.article.data.query
const getArticlesRequestParams = (state: AppState) => state.knowledge.article.requestParams
const getUrlVideo = (state: AppState) => state.knowledge.article.currentUrlVideo

export const articleSelector = {
	getArticle,
	getArticles,
	getQuery,
	getArticlesRequestParams,
	getUrlVideo,
}
